<script setup lang="ts">
import { computed } from 'vue';
import useLocale from '../../composables/useLocale';
import { useDisplay } from 'vuetify';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFont } from '@fortawesome/pro-solid-svg-icons';
library.add(faFont);

type Props = {
  modelValue: boolean; // v-model binding
};

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const { t } = useLocale();
const { smAndDown } = useDisplay();

// Map modelValue (boolean) to 0/1 for v-btn-toggle
const font = computed({
  get: () => (props.modelValue ? 1 : 0),
  set: (val: number) => {
    emit('update:modelValue', val === 1);
  },
});
</script>

<template>
  <v-list-item
    density="compact"
    data-testid="bp-setting-font-dyslexic"
    :title="t('book_player.label_text_font')"
    :aria-label="t('book_player.label_text_font')"
  >
    <template #prepend>
      <FontAwesomeIcon :size="!smAndDown ? 'xl' : 'lg'" icon="fa-solid fa-font" class="pr-3" />
    </template>
  </v-list-item>
  <v-list-item role="option">
    <v-row>
      <v-btn-toggle
        v-model="font"
        mandatory
        color="primary"
        role="radiogroup"
        class="px-5 pt-3 pb-7 justify-center"
        :aria-label="t('book_player.label_font_choice')"
        style="min-height: 5em"
      >
        <v-btn class="text-none">{{ t('label_use_font_one') }}</v-btn>
        <v-btn class="dyslexicFontButton text-none">{{ t('label_use_font_two') }}</v-btn>
      </v-btn-toggle>
    </v-row>
  </v-list-item>
</template>

<style scoped lang="scss">
@import url('../../assets/open-dyslexic/style.css');
.dyslexicFontButton {
  font-family: open-dyslexic-regular;
  font-size: 0.8rem;
}
:deep(.dyslexicFontButton .v-btn__content) {
  padding-bottom: 5px !important;
}
</style>
